import type { ChatMessage, Guest, GuestUpdate } from "@/types";
import { apiClient } from "./client";

export const guestService = {
  list: async (propertyId: string): Promise<Guest[]> => {
    const { data } = await apiClient.get<Guest[]>("/admin/guests", {
      params: { property_id: propertyId },
    });
    return data;
  },

  get: async (id: string): Promise<Guest> => {
    const { data } = await apiClient.get<Guest>(`/admin/guests/${id}`);
    return data;
  },

  update: async (id: string, body: GuestUpdate): Promise<Guest> => {
    const { data } = await apiClient.patch<Guest>(`/admin/guests/${id}`, body);
    return data;
  },

  /** Admin view of a guest's chat transcript. */
  messages: async (guestId: string): Promise<ChatMessage[]> => {
    const { data } = await apiClient.get<ChatMessage[]>("/admin/messages", {
      params: { guest_id: guestId },
    });
    return data;
  },
};
